import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=e1b45ffc"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&id=e1b45ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports